<div class="section-header d-flex justify-content-between align-items-center p-3 bg-light border-bottom">
  <h5 class="mb-0 fw-bold">Reseñas</h5>
</div>

<div *ngIf="!locationId" class="info-box m-3">
  <mat-icon>info</mat-icon>
  <span>Guarda los datos generales del centro de trabajo para poder ver las reseñas.</span>
</div>

<div *ngIf="locationId" class="reviews-section container-fluid py-3">

  <!-- Scope tabs -->
  <div class="scope-tabs mb-3">
    <button type="button" class="scope-tab" [class.active]="scope === 'location'" (click)="selectScope('location')">
      Reseñas del centro
    </button>
    <button type="button" class="scope-tab" [class.active]="scope === 'staff'" (click)="selectScope('staff')">
      Reseñas del equipo
    </button>
  </div>

  <!-- Status filter -->
  <div class="filter-row mb-3">
    <label>
      <span class="filter-label">Estado:</span>
      <select [(ngModel)]="statusFilter" (change)="changeStatusFilter()">
        <option value="all">Todas</option>
        <option value="published">Publicadas</option>
        <option value="flagged">Reportadas</option>
        <option value="hidden">Ocultas</option>
      </select>
    </label>
    <span class="total" *ngIf="!isLoading">
      {{ total }} reseña{{ total === 1 ? '' : 's' }}
    </span>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="text-center py-4">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    <p class="text-muted">Cargando reseñas…</p>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && items.length === 0" class="empty-state">
    <mat-icon>star_border</mat-icon>
    <p>Aún no hay reseñas en este filtro.</p>
  </div>

  <!-- Items -->
  <ul *ngIf="!isLoading && items.length > 0" class="review-list">
    <li *ngFor="let item of items; trackBy: trackByIndex" class="review-item">
      <div class="review-head">
        <div class="author">
          <div class="avatar" [style.backgroundImage]="item.author?.photoUrl ? 'url(' + item.author.photoUrl + ')' : null">
            <span *ngIf="!item.author?.photoUrl">{{ (item.author?.displayName || '?').charAt(0).toUpperCase() }}</span>
          </div>
          <div>
            <strong>{{ item.author?.displayName }}</strong>
            <small>
              {{ item.createdAt | date:'mediumDate' }}
              <span *ngIf="scope === 'staff' && item.staffDisplayName"> · {{ item.staffDisplayName }}</span>
            </small>
          </div>
        </div>
        <div class="status-block">
          <span class="rating-stars">
            <mat-icon *ngFor="let icon of starsArray(item.rating); trackBy: trackByIndex" class="rating-icon">{{ icon }}</mat-icon>
          </span>
          <span class="status-badge" [class.warn]="item.status === 'flagged'" [class.muted]="item.status === 'hidden'">
            {{ item.status === 'published' ? 'Publicada' : item.status === 'flagged' ? 'Reportada' : 'Oculta' }}
            <ng-container *ngIf="item.flagCount > 0"> · {{ item.flagCount }} flag(s)</ng-container>
          </span>
        </div>
      </div>

      <p *ngIf="item.comment" class="comment">{{ item.comment }}</p>

      <div class="actions">
        <button type="button" class="btn-link" (click)="toggleExpand(item.reviewId)" *ngIf="scope === 'location'">
          {{ item.response ? (expandedRow[item.reviewId] ? 'Cerrar respuesta' : 'Editar respuesta') : (expandedRow[item.reviewId] ? 'Cerrar' : 'Responder') }}
        </button>
        <button type="button" class="btn-link" *ngIf="item.status !== 'hidden'" (click)="setStatus(item, 'hidden')" [disabled]="busyRow[item.reviewId]">
          Ocultar
        </button>
        <button type="button" class="btn-link" *ngIf="item.status !== 'published'" (click)="setStatus(item, 'published')" [disabled]="busyRow[item.reviewId]">
          Publicar
        </button>
      </div>

      <!-- Existing response display (always visible if any) -->
      <blockquote *ngIf="item.response" class="response-block">
        <strong>{{ item.response.authorDisplayName || 'Centro' }}</strong>
        <p>{{ item.response.body }}</p>
        <small>{{ item.response.createdAt | date:'medium' }}</small>
      </blockquote>

      <!-- Inline response editor -->
      <div *ngIf="expandedRow[item.reviewId] && scope === 'location'" class="response-editor">
        <textarea
          rows="3"
          maxlength="2000"
          placeholder="Escribe una respuesta pública…"
          [(ngModel)]="responseBody[item.reviewId]"></textarea>
        <div class="response-actions">
          <button type="button" class="btn-primary" [disabled]="busyRow[item.reviewId]" (click)="saveResponse(item)">
            {{ item.response ? 'Actualizar' : 'Publicar respuesta' }}
          </button>
          <button type="button" class="btn-link danger" *ngIf="item.response" [disabled]="busyRow[item.reviewId]" (click)="deleteResponse(item)">
            Eliminar respuesta
          </button>
        </div>
      </div>
    </li>
  </ul>

  <!-- Pagination -->
  <nav *ngIf="!isLoading && totalPages > 1" class="pagination" aria-label="Paginación de reseñas">
    <button type="button" class="btn-link" [disabled]="page === 1" (click)="goToPage(page - 1)">‹ Anterior</button>
    <span>Página {{ page }} de {{ totalPages }}</span>
    <button type="button" class="btn-link" [disabled]="page >= totalPages" (click)="goToPage(page + 1)">Siguiente ›</button>
  </nav>
</div>
